export type SensorDataRaw = {
  city: string;
  clTag: number;
  name: string;
  phone: string;
  returnedAt: number;
}

export type SensorReturnData = {
  rUid: string;
  number: number;
  time: number;
}

export class SensorData {
  city: string;
  clTag: number;
  name: string;
  phone: string;
  returnedAt: Date | null;
  returned?: boolean;

  constructor(obj: SensorDataRaw) {
    this.city = obj.city;
    this.clTag = obj.clTag;
    this.name = obj.name;
    this.phone = obj.phone;
    this.returnedAt = obj.returnedAt ? new Date(obj.returnedAt) : null;
  }
}